
import { useEffect, useState } from "react";


import { NotificationContext } from "./NotificationContext.jsx";


// toast notification
import { ToastNotification } from "../components/notification/ToastNotification.jsx";




export const NotificationProvider = ({ children }) => {

  const [notify, setNotify] = useState({ show: false, msg: "", error: false, great: false });

  // funcion para cambiar el estado
  const handleNotify = (showP = false, msgP = "", errorP = false, greatP = false) => {
    setNotify((val) => ({ ...val, show: showP, msg: msgP, error: errorP, great: greatP }));
  };

  // cerrar la notification
  const handleClose = () => {
    setNotify({ show: false });
  };

  // limpiar las notificaciones
  useEffect(() => {
    if (notify.show) {
      const timer = setTimeout(() => {
        setNotify({ show: false });
      }, 6000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [notify.show]);

  return (
    <NotificationContext.Provider value={{ handleNotify, handleClose }}>
      {
        notify.show && (
          <ToastNotification success={notify.great} error={notify.error} msg={notify.msg} />
        )
      }
      {children}
    </NotificationContext.Provider>
  );
};